import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRejected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11,
		cy: 11,
		r: 11,
		fill: "#EF4444"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.6056 6.39427L15.6056 6.39427C15.2942 6.08284 14.7893 6.08286 14.4778 6.39427L14.4778 6.39427L10.9999 9.8722L7.52201 6.39428C7.52201 6.39428 7.52201 6.39428 7.52201 6.39428C7.21058 6.08285 6.70566 6.08285 6.39422 6.39428L6.39422 6.39428C6.08278 6.70573 6.08279 7.21065 6.39422 7.52208L6.48261 7.4337L6.39422 7.52209L9.87213 11L6.39423 14.4779L6.48243 14.5661L6.39423 14.4779C6.08281 14.7893 6.08279 15.2942 6.39423 15.6057L6.39423 15.6057C6.70567 15.9171 7.2106 15.9171 7.52202 15.6057L7.43363 15.5173L7.52202 15.6057L10.9999 12.1278L14.4778 15.6057C14.7893 15.9171 15.2942 15.9171 15.6056 15.6057C15.9171 15.2942 15.9171 14.7893 15.6056 14.4779L12.1277 11L15.6056 7.52206C15.9171 7.21063 15.9171 6.70572 15.6056 6.39427Z",
		fill: "white",
		stroke: "white",
		strokeWidth: .25
	})]
});
export default SvgRejected;
